import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { QuickBriefService } from '../../services/quick-brief.service';

@Component({
  selector: 'qb-review-step',
  templateUrl: './review-step.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex min-h-0 flex-1 flex-col overflow-hidden' },
})
export class QbReviewStep {
  readonly brief = inject(QuickBriefService);
}
